import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = [
        "intentForm",
        "confirmForm",
        "successStep",
        "title",
        "confirmEmail",
    ]

    static values = {
        titleIntent:  { type: String, default: "Slaptažodžio priminimas" },
        titleConfirm: { type: String, default: "Naujas slaptažodis" },
        titleSuccess: { type: String, default: "Slaptažodis pakeistas" },
    }

    connect() {
        this.setTitle(this.titleIntentValue)
    }

    onSuccess(e) {
        const response = e.detail.response

        if (!response) return
        if (response.general_error) return
        if (response.errors && Object.keys(response.errors).length) return

        if (e.target === this.intentFormTarget) {
            this.advanceToConfirm()
        } else if (e.target === this.confirmFormTarget) {
            this.advanceToSuccess()
        }
    }

    // ── Step transitions ──

    advanceToConfirm() {
        const emailInput = this.intentFormTarget.querySelector('input[name="email"]')
        this.confirmEmailTarget.value = emailInput ? emailInput.value : ""

        this.intentFormTarget.classList.add("d-none")
        this.confirmFormTarget.classList.remove("d-none")
        this.setTitle(this.titleConfirmValue)

        const codeInput = this.confirmFormTarget.querySelector('input[name="confirmation_code"]')
        if (codeInput) codeInput.focus()
    }

    advanceToSuccess() {
        this.confirmFormTarget.classList.add("d-none")
        this.successStepTarget.classList.remove("d-none")
        this.setTitle(this.titleSuccessValue)
    }

    // ── Navigation actions ──

    cancel(e) {
        e.preventDefault()
        this.resetToIntent()
        this.closeModal()
    }

    backToLogin(e) {
        e.preventDefault()
        this.resetToIntent()
        this.clearAllFields()
        this.closeModal()
    }

    resetToIntent() {
        this.confirmFormTarget.classList.add("d-none")
        this.successStepTarget.classList.add("d-none")
        this.intentFormTarget.classList.remove("d-none")
        this.setTitle(this.titleIntentValue)
    }

    clearAllFields() {
        this.intentFormTarget.querySelectorAll("input").forEach(el => el.value = "")
        this.confirmFormTarget.querySelectorAll("input").forEach(el => el.value = "")
    }

    // ── Helpers ──

    setTitle(text) {
        if (!this.hasTitleTarget) return
        this.titleTarget.textContent = text
    }

    closeModal() {
        this.element.dispatchEvent(new CustomEvent("modal:close", { bubbles: true }))
    }
}
